import React from 'react';
import { Upload, X } from 'lucide-react';

interface ImageUploadFieldProps {
  imagePreview: string;
  selectedFile: File | null;
  onFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveImage: () => void;
}

const ImageUploadField: React.FC<ImageUploadFieldProps> = ({
  imagePreview,
  selectedFile,
  onFileSelect,
  onRemoveImage
}) => {
  return (
    <div className="col-span-2">
      <label className="block text-xs font-bold uppercase tracking-wider text-tinta mb-2">
        Imagem do Produto
      </label>

      {/* Preview */}
      {imagePreview && (
        <div className="mb-4 relative inline-block">
          <img
            src={imagePreview}
            alt="Preview"
            className="w-32 h-32 object-cover rounded-lg border-2 border-tinta/15"
          />
          <button
            type="button"
            onClick={onRemoveImage}
            className="absolute -top-2 -right-2 bg-bordo text-creme rounded-full p-1 hover:bg-bordo-dark transition-colors"
            aria-label="Remover imagem"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      )}

      {/* Input de arquivo */}
      <div className="flex items-center space-x-2">
        <label className="flex-1">
          <input
            type="file"
            accept="image/*"
            onChange={onFileSelect}
            className="hidden"
          />
          <div className="bg-white border-2 border-dashed border-tinta/20 rounded-lg p-5 text-center cursor-pointer hover:border-bordo/50 hover:bg-bordo/5 transition-colors">
            <Upload className="mx-auto h-10 w-10 text-tinta-soft/60" strokeWidth={1.5} />
            <p className="mt-2 text-sm text-tinta font-semibold">
              {selectedFile ? selectedFile.name : 'Clique para selecionar uma imagem'}
            </p>
            <p className="text-xs text-tinta-soft italic mt-1">PNG, JPG, GIF até 5MB</p>
          </div>
        </label>
      </div>

      <p className="mt-2 text-xs text-tinta-soft italic">
        A imagem será armazenada no Amazon S3
      </p>
    </div>
  );
};

export default ImageUploadField;
